import * as React from "react";
import {History} from "history";
import {Link, Redirect} from "react-router-dom";
import logo from "./logo-c.svg";
import {isLoggedIn, logOutUser} from "../../utils/auth";
import "bulma/css/bulma.css";
import {Icon} from "bloomer";
import styled from "react-emotion";
import {userContext} from "../../utils/userContext";

const Container = styled("div")`
  grid-column: 3/11;

  @media (max-width: 1680px) {
    grid-column: 1/13;
  }
  
  @media (max-width: 768px) {
    grid-column: 1/-1;
  }
`;

const CustomHeader = styled("h1")`
  font-size: 30px;
  font-weight: 900;
  margin: auto;
`;

const StyledLink = styled(Link)`
  color: #1c2541;
`;

const Brand = styled("div")`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  line-height: 60px;
  max-height: 45px;
  color: #5b505e;
`;

const Logo = styled("img")`
  min-height: 45px;
  min-width: 45px;
  max-height: 45px;
  max-width: 45px;
  margin-right: 4px;
`;

class Header extends React.Component {
    public props: {
        history?: History;
    };

    public state = {
        showMenu: false,
        isLoggedIn: isLoggedIn()
    };

    public handleLogOut = () => {
        logOutUser();
        this.setState({isLoggedIn: false});
    };

    public onMenuClick = () => {
        this.setState({showMenu: !this.state.showMenu});
    };

    public openSettings = () => {
        this.props.history.push("/settings");
    };

    public openAPIKeys = () => {
        this.props.history.push("/api-keys");
    };

    public openRequestAI = () => {
        this.props.history.push("/request-model");
    };

    public renderUserName = (user: any) => {
        if (user) {
            const firstName = user.first_name || '';
            const lastName = user.last_name || '';
            return <div style={{
                display: 'inline-block',
                lineHeight: '48px',
                verticalAlign: 'top',
                marginRight: '5px',
                marginBottom: '5px',
                maxWidth: '320px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }}>{firstName + ' ' + lastName}</div>;
        }
        return <></>;
    };

    public renderUserProfilePicture = (user: any) => {
        if (user && user.profile_picture_url) {
            return <div style={{
                display: 'inline-block',
                padding: 0,
                margin: 0,
                height: '48px',
                width: '48px',
                border: '1px solid grey',
                borderRadius: '50%',
                backgroundPosition: 'center center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundImage: `url(${user.profile_picture_url})`
            }}/>;
        }
        return <div style={{
            border: '1px solid grey',
            borderRadius: '24px',
            width: '48px',
            height: '48px',
            padding: '12px',
            textAlign: 'center'
        }}>
            <Icon style={{fontSize: '24px'}} className="fas fa-user"/>
        </div>;
    };

    public render() {
        return (
            <Container>
                {!this.state.isLoggedIn ? <Redirect to="/login"/> : ""}
                <nav className="navbar">
                    <div className="navbar-brand">
                        <StyledLink className="navbar-item" to="/">
                            <CustomHeader>
                                <Brand>
                                    <Logo src={logo}/>
                                    GenesisAI
                                </Brand>
                            </CustomHeader>
                        </StyledLink>
                        <a
                            role="button"
                            className="navbar-burger"
                            aria-label="menu"
                            aria-expanded="true"
                            onClick={this.onMenuClick}
                        >
                            <span aria-hidden="true"/>
                            <span aria-hidden="true"/>
                            <span aria-hidden="true"/>
                        </a>
                    </div>
                    <div className={"navbar-menu" + (this.state.showMenu ? " is-active" : "")}>
                        <div className="navbar-end">
                            <div className="navbar-item has-dropdown is-hoverable">
                                <a className="navbar-link is-arrowless">
                                    <userContext.Consumer>
                                        {this.renderUserName}
                                    </userContext.Consumer>
                                    <userContext.Consumer>
                                        {this.renderUserProfilePicture}
                                    </userContext.Consumer>
                                </a>

                                <div className="navbar-dropdown is-right">
                                    <a className="navbar-item" onClick={this.openSettings}>
                                        <Icon className="fas fa-cog" style={{marginRight: '5px'}}/>Settings
                                    </a>
                                    <a className="navbar-item" onClick={this.openAPIKeys}>
                                        <Icon className="fas fa-key" style={{marginRight: '5px'}}/>API Keys
                                    </a>
                                    <a className="navbar-item" onClick={this.openRequestAI}>
                                        <Icon className="fas fa-align-justify" style={{marginRight: '5px'}}/>Request AI
                                    </a>
                                    <a className="navbar-item" onClick={this.handleLogOut}>
                                        <Icon className="fas fa-sign-out-alt" style={{marginRight: '5px'}}/>Sign
                                        Out
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </Container>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/index.tsx